import { Guest } from '@/app/system/guest/Guest';
import { AxiosRequest } from '@/app/integration/axios/request/AxiosRequest';
import { GuestDynamic } from '@/app/system/guest/GuestDynamic';
import { Loading } from '@/app/system/process/Loading';
import { Patron } from '@/app/system/guest/Patron';
import { RequestPart } from '@/app/system/request/RequestPart';
import { GuestAware } from '@/app/system/guest/GuestAware';
import { RuntimeError } from '@/app/system/error/RuntimeError';
import { Response } from '@/app/system/response/Response';
import debounce from 'lodash/debounce';
import { PatronPoolWithGuests } from '@/app/system/guest/PatronPoolWithGuests';

/**
 * @deprecated legacy
 */
export class AxiosResponse<T> implements Response<T> {
  private pagePool = new PatronPoolWithGuests<T>(this)
  private withLoading = new Loading();
  private cancelFns: (() => void)[] = [];

  public constructor(private requestPart: RequestPart, private resendReasons: GuestAware<unknown>[] = []) {
    let needToDoRequest = false;
    let isSilent = false;

    const scheduleRequest = debounce(() => {
      // Не важно сколько причин для перезапроса появится, делаем один запрос
      if (needToDoRequest) {
        this.doRequest(isSilent);
        needToDoRequest = false;
        isSilent = false;
      }
    }, 100);

    resendReasons.forEach(resendReason => {
      resendReason.receiving(new Patron(new GuestDynamic((newVal, options) => {
        const oldVal = options?.specificData?.oldValue;
        isSilent = isSilent || !!options?.specificData?.silent;
        if (oldVal !== undefined && newVal !== oldVal) {
          needToDoRequest = true;
          scheduleRequest();
        }
      })));
    });
  }

  public content(guest: Guest<T>, errorGuest?: Guest<any>): Loading {
    this.pagePool.add(guest);
    this.doRequest(false, errorGuest);

    return this.withLoading;
  }

  public schedule(guest: Guest<T>): Loading {
    if (guest.introduction() !== 'patron') {
      throw new RuntimeError('Scheduled object must be patron in AxiosResponse', {});
    }
    if (!this.resendReasons.length) {
      throw new RuntimeError('No resend reasons in AxiosResponse scheduling impossible!', {});
    }
    this.pagePool.add(guest);
    return this.withLoading;
  }

  public loading() {
    return this.withLoading;
  }

  private doRequest(isSilent: boolean = false, errorGuest?: Guest<any>) {
    let isCancelled = false;
    this.cancelFns.forEach(c => c());
    const request = new AxiosRequest(this.requestPart);
    !isSilent && this.withLoading.receive(true);
    request.response(new GuestDynamic((value: any, options) => {
      if (value?.data) {
        this.pagePool.receive(value.data as T, options);
      }
      if (!isCancelled) {
        !isSilent && this.withLoading.receive(false);
      }
    }), c => {
      if (isSilent) {
        this.cancelFns.push(c);
      }
    }, () => {
      isCancelled = true;
    },
    errorGuest,
    );
  }

  id(guest: Guest<string>) {
    this.requestPart.request(new GuestDynamic(value => {
      guest.receive(JSON.stringify(value));
    }));
    return this;
  }
}
